module.exports = __webpack_public_path__ + "static/media/hbg1.e0333357.jpg";